import { createCoreMethod } from '../../utils/createCoreMethod';

export const clearTemp = createCoreMethod('clearTemp', async () => {
  const nodes = figma.currentPage.children.filter(
    (node) => node.name === 'velocity-temp-data'
  );

  if (nodes && nodes.length > 0) {
    nodes.forEach((node) => node.remove());
  }
});
